import React from 'react';
import {t} from '@lingui/core/macro';

import RefreshButton from 'shared/ui/IconButton/RefreshButton';
import SummaryStatus from 'shared/ui/SummaryStatus/SummaryStatus';

import styles from './IncidentsSummary.module.scss';

export interface IIncidentsSummaryProps {
    unresolved?: number,
    resolved?: number,
    isLoading?: boolean,
    isError?: boolean,
    refetch?: () => void,
}

const IncidentsSummary: React.FC<IIncidentsSummaryProps> = ({
    unresolved = 0,
    resolved = 0,
    isLoading = false,
    isError = false,
    refetch,
}) => {
    if (isLoading) {
        return (
            <div className={styles.skeletonStatus}>
                <div className={styles.skeletonItem}/>
                <div className={styles.skeletonItem}/>
            </div>
        );
    }

    if (isError && refetch) {
        return (
            <div className={styles.error}>
                <span>{t`Ошибка загрузки статистики`}</span>
                <RefreshButton title={t`Повторить`} onClick={refetch}/>
            </div>
        );
    }

    return <SummaryStatus unresolved={unresolved} resolved={resolved}/>;
};

export default IncidentsSummary;
